/**
 * Outcome of hydrating a referenced record on an activity event.
 */
export enum ActivityHydrationStateEnum {
  RESOLVED = 'resolved',
  DELETED = 'deleted',
  MISSING = 'missing',
}
